/*
Vertical Navigation with RBAC
*/

import dashboard from './dashboard'
import appsAndPages from './apps-and-pages'

const role = localStorage.getItem('role')
const alwaysVisible = ['Change password'] // 🔹 Always visible for all roles

let navigation = []

/* =====================================================
   SUPER ADMIN → ALL SCREENS
===================================================== */
if (role === 'super-admin') {
  navigation = [
    ...dashboard,
    ...appsAndPages,
    ...alwaysVisible,
  ]
}

/* =====================================================
   ADMIN → ALL EXCEPT SOME SCREENS
===================================================== */
else if (role === 'admin') {
  const adminRestrictedScreens = [
    'Packages',
    'Advertisement',
    'Terms & Conditions',
    'Privacy Policy',
  ]

  navigation = [
    ...dashboard,
    ...appsAndPages
      .map(item => {
        if (item.children && item.children.length) {
          const filteredChildren = item.children.filter(
            child =>
              !adminRestrictedScreens.includes(child.title) ||
              alwaysVisible.includes(child.title)
          )

          const hasAlwaysVisibleChild = item.children.some(c =>
            alwaysVisible.includes(c.title)
          )

          return filteredChildren.length || hasAlwaysVisibleChild
            ? { ...item, children: filteredChildren.length ? filteredChildren : item.children.filter(c => alwaysVisible.includes(c.title)) }
            : null
        }

        return adminRestrictedScreens.includes(item.title) && !alwaysVisible.includes(item.title)
          ? null
          : item
      })
      .filter(Boolean),
    ...alwaysVisible,
  ]
}

/* =====================================================
   MEMBER → RESTRICTED SCREENS HIDDEN
===================================================== */
else if (role === 'member') {
  const memberRestrictedScreens = [
    'Push Notifications',
    'Talent (Under 18)',
    'Packages',
    'Advertisement',
    'Reports',
    'Analysis Reports',
    'Referrals',
    'Terms & Conditions',
    'Privacy Policy'
  ]

  const allowedScreens = appsAndPages // basically everything except restricted
    .map(item => {
      if (item.children && item.children.length) {
        const filteredChildren = item.children.filter(
          child => !memberRestrictedScreens.includes(child.title) || alwaysVisible.includes(child.title)
        )

        const hasAlwaysVisibleChild = item.children.some(c =>
          alwaysVisible.includes(c.title)
        )

        return filteredChildren.length || hasAlwaysVisibleChild
          ? { ...item, children: filteredChildren.length ? filteredChildren : item.children.filter(c => alwaysVisible.includes(c.title)) }
          : null
      }

      return memberRestrictedScreens.includes(item.title) && !alwaysVisible.includes(item.title)
        ? null
        : item
    })
    .filter(Boolean)

  navigation = [
    ...dashboard,
    ...allowedScreens
  ]
}

/* =====================================================
   COORDINATOR → TALENT SCREENS ONLY
===================================================== */
else if (role === 'coordinator') {
  const talentScreens = [
    'Dashboard',
    'Teams',
    'Talents',
    'Talents (Under 18)',
    'Talent Scouts',
    'Geo Verse',
    'Geo Nexus',
    'Posts',
    'Reports',
    ...alwaysVisible,
  ]

  navigation = [
    ...dashboard,
    ...appsAndPages
      .map(item => {
        if (item.children && item.children.length) {
          const filteredChildren = item.children.filter(child =>
            talentScreens.includes(child.title)
          )
          return filteredChildren.length ? { ...item, children: filteredChildren } : null
        }

        return talentScreens.includes(item.title) ? item : null
      })
      .filter(Boolean),
  ]
}

/* =====================================================
   FALLBACK → NOT LOGGED IN
===================================================== */
else {
  navigation = []
}

export default navigation